"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateBasketTitle = exports.startSearchByOffer = exports.showSaveOfferToBasketModal = exports.setPage = exports.setActiveEditingBasketID = exports.setActiveBasketID = exports.resetStore = exports.removeOfferFromBasket = exports.removeOfferFromActiveBasket = exports.removeBasket = exports.initAutoCloseModal = exports.getActiveBasket = exports.disappearActiveBasket = exports.createBasketWithOffer = exports.changePage = exports.addOfferToBasket = void 0;
var _reduxActions = require("redux-actions");
var _actions = require("../../../../bus/ui/actions");
var _constants = require("./constants");
var _createActions = (0, _reduxActions.createActions)({
    showSaveOfferToBasketModal: function showSaveOfferToBasketModal(offerID, queryID, callbacks) {
      return {
        offerID: offerID,
        queryID: queryID,
        callbacks: callbacks
      };
    },
    updateBasketTitle: function updateBasketTitle(basketID, title, onSuccess) {
      return {
        basketID: basketID,
        title: title,
        onSuccess: onSuccess
      };
    },
    createBasketWithOffer: function createBasketWithOffer(offerID, queryID, callbacks) {
      return {
        offerID: offerID,
        queryID: queryID,
        callbacks: callbacks
      };
    },
    setActiveEditingBasketID: function setActiveEditingBasketID(basketID) {
      return basketID;
    },
    addOfferToBasket: function addOfferToBasket(offerID, basketID, queryID, callbacks) {
      return {
        offerID: offerID,
        queryID: queryID,
        basketID: basketID,
        callbacks: callbacks
      };
    },
    setPage: function setPage(page) {
      return page;
    },
    removeOfferFromBasket: function removeOfferFromBasket(offerID, basketID, callbacks) {
      return {
        offerID: offerID,
        basketID: basketID,
        callbacks: callbacks
      };
    },
    removeOfferFromActiveBasket: function removeOfferFromActiveBasket(offerID, basketID) {
      return {
        offerID: offerID,
        basketID: basketID
      };
    },
    startSearchByOffer: function startSearchByOffer(hotelID, offerID) {
      return {
        hotelID: hotelID,
        offerID: offerID
      };
    },
    removeBasket: function removeBasket(basketID, onSuccess) {
      return {
        basketID: basketID,
        onSuccess: onSuccess
      };
    },
    getActiveBasket: function getActiveBasket(basketID) {
      return basketID;
    },
    setActiveBasketID: function setActiveBasketID(basketID) {
      return basketID;
    },
    resetStore: function resetStore() {
      return undefined;
    },
    initAutoCloseModal: function initAutoCloseModal() {
      return undefined;
    },
    changePage: function changePage(page, limit) {
      return {
        page: page,
        limit: limit
      };
    }
  }, {
    prefix: 'SAVE_OFFER_TO_BASKET_MODAL'
  }),
  showSaveOfferToBasketModal = exports.showSaveOfferToBasketModal = _createActions.showSaveOfferToBasketModal,
  updateBasketTitle = exports.updateBasketTitle = _createActions.updateBasketTitle,
  createBasketWithOffer = exports.createBasketWithOffer = _createActions.createBasketWithOffer,
  setActiveEditingBasketID = exports.setActiveEditingBasketID = _createActions.setActiveEditingBasketID,
  addOfferToBasket = exports.addOfferToBasket = _createActions.addOfferToBasket,
  setPage = exports.setPage = _createActions.setPage,
  removeOfferFromBasket = exports.removeOfferFromBasket = _createActions.removeOfferFromBasket,
  removeOfferFromActiveBasket = exports.removeOfferFromActiveBasket = _createActions.removeOfferFromActiveBasket,
  startSearchByOffer = exports.startSearchByOffer = _createActions.startSearchByOffer,
  getActiveBasket = exports.getActiveBasket = _createActions.getActiveBasket,
  setActiveBasketID = exports.setActiveBasketID = _createActions.setActiveBasketID,
  resetStore = exports.resetStore = _createActions.resetStore,
  removeBasket = exports.removeBasket = _createActions.removeBasket,
  initAutoCloseModal = exports.initAutoCloseModal = _createActions.initAutoCloseModal,
  changePage = exports.changePage = _createActions.changePage;
var disappearActiveBasket = exports.disappearActiveBasket = function disappearActiveBasket() {
  return (0, _actions.update)(_constants.GET_ACTIVE_BASKET_UI, {
    animating: false
  });
};